<cc-icon
    #anchor
    title="Export"
    [icon]="'logout'"
    [size]="'medium'"
    (iconClicked)="showModal = !showModal"
/>

@if (showModal) {
    <ddv-dashboard-export-form
        [ccModal]="modalOptions"
        [widgets]="widgets"
        [hasCrosstalkData]="hasCrosstalkData"
        (dismissed)="showModal = false"
        (exportPDF)="exportToPDF()"
        (exportExcel)="exportToExcel($event)"
    >
    </ddv-dashboard-export-form>
}
